export default "__VITE_ASSET__ca0a540f__"